import { render, staticRenderFns } from "./filterReleasePatients.vue?vue&type=template&id=dcd7a560&scoped=true"
import script from "./filterReleasePatients.vue?vue&type=script&lang=js"
export * from "./filterReleasePatients.vue?vue&type=script&lang=js"
import style0 from "./filterReleasePatients.vue?vue&type=style&index=0&id=dcd7a560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd7a560",
  null
  
)

export default component.exports